import React,{useState,useEffect} from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import PacmanLoader from "react-spinners/PacmanLoader";
import {useNavigate} from "react-router-dom";

const styleTittle = {

    fontSize: 20,

    color: "#4a54f1",

    textAlign: "center",

    paddingBottom: "60px",
}

const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const TambahBarang = () => {
const [kodeBarang, setKodeBarang] = useState("");
const [cabang, setCabang] = useState("");
const [namaBarang, setNamaBarang] = useState("");
const [kodeKategori, setKodeKategori] = useState("-----");
const [qtyMax, setQtyMax] = useState("");
const [qtyMin, setQtyMin] = useState("");
const [stok, setStok] = useState("");
const [ket, setKet] = useState("");
const [loading, setLoading] = useState(false);
const navigate = useNavigate();

const [kategori,setKategori] = useState([]);

useEffect(() => {
    getKategori();
},[]);


const getKategori = async () => {
    const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/kategori`);
    console.log("ini hasil get",response.data[0]);
    setKategori(response.data[0]);
}

const saveBarang = async (e) =>{
    e.preventDefault();
    setLoading(true)
    if(kodeKategori==="-----"){
        alert("Silahkan Pilih Kategori Barang...");
    }else{
    let formData = new FormData();
            formData.append('kodeBarang',kodeBarang);
            formData.append('cabang',cabang);
            formData.append('namaBarang',namaBarang);
            formData.append('kodeKategori',kodeKategori);
            formData.append('qtyMin',qtyMin);
            formData.append('qtyMax',qtyMax);
            formData.append('stok',stok);
            formData.append('ket',ket);
    try {
        await axios.post(`${process.env.REACT_APP_MASTER_URL}/tambahbarang`,formData,{
            headers:{ 
                'Content-Type':'multipart/form-data'
            }
        });
        toast.info("Barang Berhasil Ditambahkan");
        navigate("/")
    } catch (error) {
        setLoading(false)
        toast.error("Gagal, Kesalahan Server");
        console.log("error: ",error);
    }
        }     
}

  return (
    <section className="hero has-background-grey-light is-fullheight is-fullwidth">
        {loading ?
            <div style={stylespinner}>
                <PacmanLoader
                    color={'#301E67'}
                    loading={loading}
                    size={30}
                    textAlign='centered'
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                </div> 
        :
        <div className="section is-fullheight" style={{backgroundColor: '#1b48f1', filterImage:'blur(50px)'}} >
        <div className="container is-centered">
            <div className="column is-6 is-offset-3">
            <div className="box" >
                    <img src={`${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`}  alt="Not Found" width={300} height={300}></img>
                    <label className='label' style={styleTittle}><center>Form Tambah Barang</center></label>
                <form onSubmit={saveBarang}>
                <div className='field'>
                        <label className='label'>Kode Barang</label>
                        <div class='control' has-icons-left has-icons-right>
                            <input required type='text' className="input" value={kodeBarang} onChange={(e)=> setKodeBarang(e.target.value)} placeholder='Nama Barang'></input>                    </div>
                    </div>
                    <div className='field'>
                            <label className='label'>Cabang</label>
                            <div className='control'>
                                <div className='select is-fullwidth'>
                                    <select required value={cabang} onChange={(e)=> setCabang(e.target.value)}>
                                        <option value=''>--Silahkan Pilih--</option>
                                        <option value="Wlingi">Wlingi</option>
                                        <option value="Kepanjen">Kepanjen</option>
                                        <option value="Brondong">Brondong</option>
                                        <option value="Gresik">Gresik</option>
                                        <option value="Tuban">Tuban</option>
                                        <option value="Ngadiluwih">Ngadiluwih</option>
                                        <option value="Ngunut">Ngunut</option>
                                        <option value="Situbondo">Situbondo</option>
                                        <option value="Genteng">Genteng</option>
                                        <option value="Rambipuji">Rambipuji</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    <div className='field'>
                        <label className='label'>Nama Barang</label>
                        <div class='control' has-icons-left has-icons-right>
                            <input required type='text' className="input" value={namaBarang} onChange={(e)=> setNamaBarang(e.target.value)} placeholder='Nama Barang'></input>                    </div>
                    </div>
                    <div className='field'>
                        <label className='label'>Kategori</label>
                        <div className='control'>
                            <div className='select is-fullwidth'>
                                <select required value={kodeKategori} onChange={(e)=> setKodeKategori(e.target.value)}>
                                <option value="-----">--Silahkan Pilih--</option>
                                {kategori.map((kategori, index) => (
                                        <option value={kategori.kodeKategori}>{kategori.jenisKategori}</option>
                                ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='field'>
                        <label className='label'>Stok Maksimal</label>
                        <div className='control'>
                            <input required type='number' className="input" value={qtyMax} onChange={(e)=> setQtyMax(e.target.value)} placeholder='Masukan Angka'></input>
                        </div>
                    </div>
                    <div className='field'>
                        <label className='label'>Stok Minimal</label>
                        <div className='control'>
                            <input required type='number' className="input" value={qtyMin} onChange={(e)=> setQtyMin(e.target.value)} placeholder='Masukan Angka'></input>
                        </div>
                    </div>
                    <div className='field'>
                        <label className='label'>Stok </label>
                        <div className='control'>
                            <input required type='number' className="input" value={stok} onChange={(e)=> setStok(e.target.value)} placeholder='Stok Saat Ini'></input>
                        </div>
                    </div>
                    <div className='field'>
                        <label className='label'>Keterangan</label>
                        <div className='control'>
                            <input required type='text' className="input" value={ket} onChange={(e)=> setKet(e.target.value)} placeholder='Keterangan'></input>
                        </div>
                    </div>
                    <div className='field mt-5'>
                        <button type='submit' className='button is-link'>Save</button>
                        <button type="button" onClick={() => navigate(-1)} className='button is-primary ml-5'>Back</button>
                    </div>
                </form>
            </div>
        </div>
        </div>
        </div>
        }
    </section>
  )
}

export default TambahBarang